import React, { useEffect } from "react"
import RCT2Scenario from "../components/RCT2Downloads/RCT2Scenario/RCT2Scenario"

function Downloads(props) {
  useEffect(() => {document.title = props.title})
  
  return (
    <main id="main-content">
      <h1>{props.title}</h1>
    
      <div id="downloads">
        <h2>Downloads from Least1234</h2>
        
        <RCT2Scenario />
      </div>
    </main>
  )
}

export default Downloads